import {
	getHexCode,
	isValidHexCode,
} from '@/products/flexible-web-toolkit/colors/registry'

export function getColorHex(colorKey: string): string | undefined {
	// 1. Check the registry by ID or alias
	const hex = getHexCode(colorKey)
	if (hex) return hex

	// 2. If the input is already a valid hex code, return it directly
	if (isValidHexCode(colorKey)) {
		return colorKey.startsWith('#') ? colorKey : `#${colorKey}`
	}

	return undefined
}
